/**
 * Formats a single-line CVE risk formula string into a multi-line display format.
 * e.g. "10 * ((CVSS_BASE * 0.5) + (EXPLOIT_KEV * 0.2))"
 * becomes:
 * "10 * (
 *   (CVSS_BASE * 0.5)
 *   + (EXPLOIT_KEV * 0.2))"
 */
export function formatFindingScoreAlgorithm(raw: string | undefined): string {
  if (!raw) return "";
  return raw.replace(/\s*\+\s*\(/g, "\n  + (").replace(/\(\s*\(/g, "(\n  (");
}
